import React, { Children } from "react";
import Icon from "@material-ui/core/Icon";

/**
  <GrandChallenges options={}
    joins={}
    focusKey={}
    focus={}
    addItem={}
    removeItem={}
  >
 */
const GrandChallenges = (props) => {
  const key = "gr_chall_checklist";
  const joinsByChallId = props.joins.reduce(
    (acc, j) => (acc[j.grand_challenge_id] = j) && acc,
    {}
  );
  const grand_challenges = props.options.map((opt) => {
    const join = joinsByChallId[opt.id];
    return (
      <Checkbox {...props} key={`${key}-${opt.id}`} option={opt} join={join} />
    );
  });

  return <div id={key}>{grand_challenges}</div>;
};

/**
 * <Checkbox {...props} option={} join={} />
 **/
const Checkbox = (props) => {
  const changeFunc =
    props.join === undefined ? props.addItem : props.removeItem;
  const changeOpts =
    props.join === undefined
      ? {
          type: "syl_grand_challenge",
          plType: "syl_grand_challenges",
          field: "grand_challenge_id",
          value: props.option.id,
        }
      : {
          type: "syl_grand_challenge",
          plType: "syl_grand_challenges",
          id: props.join.id,
          skipConfirm: true,
        };

  let input = props.editMode ? (
    <span className="pr-5">
      <input
        id={`chall-${props.option.id}-chkbx`}
        type="checkbox"
        onChange={(e) => changeFunc(changeOpts, e)}
        checked={props.join !== undefined}
      />
    </span>
  ) : (
    ""
  );

  return props.editMode || props.join != null ? (
    <span
      className="d-flex justify-content-left align-items-center"
      key={`chall-${props.option.id}-chkbx`}
    >
      {input}
      <label
        htmlFor={`chall-${props.option.id}-chkbx`}
        className="d-flex align-items-center"
      >
        <strong className="d-flex align-items-center mr-2">
          <Icon className="mr-2">{props.option.icon}</Icon>
          {props.option.name}:
        </strong>
        {props.option.description}
      </label>
    </span>
  ) : null;
};

export default GrandChallenges;
